<script lang="ts">
  import { beforeNavigate, goto } from "$app/navigation";
  import { page } from "$app/stores";
  import { tooltip } from "app/actions/tooltip";
  import IconButton, {
    type IconButtonVariants,
  } from "$components/+blocks/IconButton/IconButton.svelte";
  import { fade } from "svelte/transition";
  import cx from "classnames";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";

  export let path: string;
  export let routeId: string | undefined;
  export let title: string;
  export let icon: IconType | null = null;
  export let image: string | null = null;
  export let disabled = false;

  let variant: IconButtonVariants;
  let isCurrentLocation: boolean;

  $: {
    if (routeId && $page.route.id) {
      isCurrentLocation = $page.route.id.startsWith(routeId);
    }
  }

  $: variant = isCurrentLocation && !disabled ? "active" : "tertiary";

  beforeNavigate((nav) => {
    const targetPath = `/${nav.to?.url.pathname}`;
    isCurrentLocation = `/${targetPath}`.includes(path);
  });
</script>

<span in:fade={{ duration: 100 }}>
  {#if icon}
    <IconButton
      {icon}
      {variant}
      {disabled}
      a11yLabel={title}
      tooltipPosition="right"
      ariaRole="link"
      size="large"
      customIconSize="size-5"
      on:click={() => goto(path)}
    />
  {:else if image}
    <button
      use:tooltip
      type="button"
      {title}
      class={cx(
        "group flex size-[36px] items-center justify-center overflow-hidden rounded-lg p-[6px] text-neutral-500 transition-all duration-100 hover:text-neutral-600",
        {
          "bg-neutral-900/10 shadow-[0px_1px_1px_0px_rgba(0,0,0,0.25)] dark:bg-white/15 dark:shadow-[0px_1px_1px_0px_rgba(0,0,0,1)]":
            isCurrentLocation,
          "hover:bg-black/8 dark:hover:bg-white/12": !isCurrentLocation,
        }
      )}
      on:click={() => goto(path)}
    >
      <img
        src={image}
        alt={title}
        class={cx(
          "size-full rounded bg-neutral-400 transition-colors duration-100 group-hover:bg-neutral-500/80 dark:bg-neutral-800 group-hover:dark:bg-neutral-900/80",
          {
            "bg-neutral-500/80 dark:bg-neutral-900/80": isCurrentLocation,
          }
        )}
      />
    </button>
  {/if}
</span>
